<section appReveal class="ls-section w-full px-4 sm:px-8" [class.ls-heading-right]="headingAlign === 'right'">
    @if (layout === 'center') {
        <div class="ls-center-inner r-rise mx-auto flex w-full max-w-[880px] flex-col items-center text-center">
            <h2 class="ls-heading font-outfit font-bold" [innerHTML]="section.headingHtml"></h2>
            @if (paragraphs.length) {
                <div class="ls-prose font-inter space-y-4 mt-6">
                    @for (paragraph of paragraphs; track $index) {
                        <p>{{ paragraph }}</p>
                    }
                </div>
            }
        </div>
    } @else {
        <div appSpotlight class="ls-inner r-rise mx-auto grid w-full max-w-[1200px] items-center gap-8 lg:grid-cols-2 lg:gap-12"
            [class.ls-card]="card">
            @if (link) {
                <a [routerLink]="link" class="ls-heading-link">
                    <h2 class="ls-heading font-outfit font-bold" [innerHTML]="section.headingHtml"></h2>
                </a>
            } @else {
                <h2 class="ls-heading font-outfit font-bold" [innerHTML]="section.headingHtml"></h2>
            }
            @if (paragraphs.length) {
                <div class="ls-prose font-inter space-y-4">
                    @for (paragraph of paragraphs; track $index) {
                        <p>{{ paragraph }}</p>
                    }
                </div>
            }
        </div>
    }
</section>
